import { MwlIcons } from "../components/MwlIcons";

export const ExifComponent = ({ icon, name, aria, value }) => (
  <div className="exif" aria-label={aria} role="group">
    <MwlIcons icon={icon} />
    <span> &nbsp;{value}</span>
  </div>
);
